import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure,
} from '@chakra-ui/react';
import React from 'react';

type TProps = {
    children: React.ReactElement;
    title: string | React.ReactElement;
    trigger?: React.ReactElement;
    withoutCancel?: boolean;
    submitText?: string;
    onSubmit?: () => void;
    disabled?: boolean;
    danger?: boolean;
    size?: string;
    loading?: boolean;
    forceIsOpen?: boolean;
    setOpen?: (value: boolean) => void;
    withoutSubmit?: boolean;
};

const Dialog = ({
    trigger,
    title,
    children,
    submitText,
    onSubmit,
    withoutCancel = false,
    disabled,
    danger,
    size,
    loading,
    forceIsOpen,
    setOpen,
    withoutSubmit = false,
}: TProps) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const clonedElement = trigger && React.cloneElement(trigger, { onClick: onOpen });

    const handleSubmit = () => {
        onSubmit();
    };

    const handleClose = () => {
        onClose();
        setOpen && setOpen(false);
    };

    return (
        <>
            {clonedElement}
            <Modal isOpen={forceIsOpen || isOpen} onClose={handleClose} isCentered size={size}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader padding="24px" lineHeight={1} fontSize="20px">
                        {title}
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody padding="0 24px">{children}</ModalBody>
                    {!(withoutCancel && withoutSubmit) && (
                        <ModalFooter padding="24px">
                            {!withoutCancel && (
                                <Button variant="outline" onClick={handleClose}>
                                    Cancel
                                </Button>
                            )}
                            {!withoutSubmit && (
                                <Button
                                    variant={danger ? 'danger' : 'brand'}
                                    onClick={handleSubmit}
                                    height="48px"
                                    padding="0 24px"
                                    ml="8px"
                                    isDisabled={disabled}
                                    isLoading={loading}
                                >
                                    {submitText}
                                </Button>
                            )}
                        </ModalFooter>
                    )}
                </ModalContent>
            </Modal>
        </>
    );
};

export default Dialog;
